// What kind of phone we are on, and what that changes. ONE test for "low-end",
// shared by the squircle engine (no glows) and the 3D tale library (LITE mode).
export const LOW_END = typeof window !== "undefined" && (
  /[?&]lite=1/.test(window.location.search) ||
  (navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 2);

// While the app is in the background (the messenger on top, the screen off), every
// CSS animation is paused — they keep the GPU busy for nobody otherwise. The rule
// that does it is `html.zg-bg` in BASE_CSS. Called once by each shell.
export function pauseAnimationsWhenHidden() {
  if (typeof document === "undefined" || document.__zgPause) return;
  document.__zgPause = true;
  const sync = () => document.documentElement.classList.toggle("zg-bg", document.hidden);
  document.addEventListener("visibilitychange", sync);
  sync();
}
